import { FieldType } from './widgetFieldTypes.const';

export const CONFIRMATION_REDIRECT_OPTIONS = {
	withAnimation: 0,
	withoutAnimation: 1,
	defaultPage: 2,
};

export const MINIAPPS_USING_CONFIRMATION_REDIRECT = [FieldType.Calendly, FieldType.HubSpotScheduler, FieldType.Stripe];
